import { Component, OnDestroy, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { ConfigValuesService } from 'src/app/features-common/services/config-values.service';
import { ReportsService } from 'src/app/features/consumer-report/reports.service';

@Component({
  selector: 'app-commision-smart',
  template: `<app-batch-export [batchexport]="batchexport" [disclaimerText]="disclaimerText"></app-batch-export>`,
  styles: [
  ]
})
export class BatchExportSmartComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {

  batchexport: any =[];
  disclaimerText: string;

  constructor(private reportsService: ReportsService, private uiConfigService: ConfigValuesService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit()
    this.reportsService.batchExportList().subscribe(res => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
        this.batchexport=resData;
      }
    })
    this.uiConfigService.getUIConfigValues('Batch Disclaimer').subscribe(res => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
        this.disclaimerText = resData;
      }
    })
	}

  ngOnDestroy() {
    super.ngOnDestroy()
  }

}
